/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RetrieveSupplierConditionsRestResponse } from '../../models/retrieve-supplier-conditions-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindSupplierConditionById$Params {
  id: string;
}

export function findSupplierConditionById(
  http: HttpClient,
  rootUrl: string,
  params: FindSupplierConditionById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RetrieveSupplierConditionsRestResponse>> {
  const rb = new RequestBuilder(rootUrl, findSupplierConditionById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RetrieveSupplierConditionsRestResponse>;
    }),
  );
}

findSupplierConditionById.PATH = '/supplier-condition/{id}';
